import request from '@/utils/request'
import URL from './urlTranslator'

export function getIpWhiteList(type) {
  return request({
    url: `${URL.sys.ipConfigFilter}/${type}`,
    method: 'get'
  })
}

export function addIpWhite(data, type) {
  return request({
    url: `${URL.sys.ipConfigFilter}/${type}`,
    method: 'post',
    data
  })
}

export function delIpWhite(data) {
  return request({
    url: URL.sys.ipConfigFilter,
    method: 'delete',
    data
  })
}
